import { render, staticRenderFns } from "./CarCharges.vue?vue&type=template&id=566a2408&scoped=true&"
import script from "./CarCharges.vue?vue&type=script&lang=js&"
export * from "./CarCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a2408",
  null
  
)

export default component.exports